//抽奖PC WAP公用数据
import { $subscriber } from "fire-wind-water";
import ws from "../services/webinar";

export function buildLotteryData(data) {
  return Object.assign(
    {
      luckyName: "",
      awardName: "",
      isShowLuckying: false,
      isShowLuckyList: false,
      isShowWinningList: false,
      isWinner: false,
      user: {},
      webinarInfo: {},
      luckyList: [],
      message: "",
      luckyDrawDefImg: require("../assets/images/luckyDrow.jpg")
    },
    data
  );
}

export function buildTableMethod(otherMethods) {
  return Object.assign(
    {
      close() {
        this.isShowLuckying = false;
        this.isShowLuckyList = false;
        this.isShowWinningList = false;
      },
      showLuckying() {
        this.isShowLuckyList = false;
        this.isShowWinningList = false;
        this.isShowLuckying = true;
      },
      showLuckyList() {
        this.isShowLuckying = false;
        this.isShowWinningList = false;
        this.isShowLuckyList = true;
      },
      encryptUserInfo(val, type) {
        var encryptor = {
          email: function(val) {
            var prefix = val.replace(/^(.*)@.*$/, "$1");
            if (prefix.length < 5) {
              return val.replace(/^[^@]*@(.*)$/, "****@$1");
            }
            return val.replace(/^(\w{2}).*(\w{2})@(.*)$/, "$1****$2@$3");
          },
          qq: function(val) {
            if (val.length < 4) {
              return val[0] + "****";
            }
            return val.replace(/^(\d{2})\d+(\d{2})$/, "$1****$2");
          },
          mobile: function(val) {
            if (val.length !== 11) {
              return val.replace(/^(.*)([\w]{4})$/, "****$2");
            }
            return val.replace(/^(\w{3})\w{4}(\w{4})$/, "$1****$2");
          }
        };
        if (Object.prototype.hasOwnProperty.call(encryptor, type)) {
          if (typeof val !== "string") {
            return val;
          }

          return encryptor[type](val);
        }

        return val;
      },

      //获取显示名
      getShowName(userInfo, index) {
        let self = this;
        var infoList = ["mobile", "email", "qq", "nickName"];
        if (!index) {
          index = 0;
        }
        var userName = userInfo["userName"] || userInfo["realName"] || "";
        if (!userName.length) {
          userName = "匿名";
        }
        var info = infoList[index];
        if (userInfo[info]) {
          return userName + " " + self.encryptUserInfo(userInfo[info], info);
        } else {
          if (index < infoList.length) {
            index++;
            return self.getShowName(userInfo, index);
          } else {
            return userName;
          }
        }
      },
      getLuckyDrawRoster() {
        var self = this;
        let params = {
          tenantId: self.webinarInfo.tenantId,
          instanceId: self.webinarInfo.instanceId
        };
        ws.getLotteryRecord(params).subscribe(data => {
          if (data.result == 0) {
            let list = data.content;
            for (let i in list) {
              self.winnerListHandler(list[i].members);
            }
            self.luckyList = list;
            self.isShowLuckying = false;
            self.isShowLuckyList = false;
            self.isShowWinningList = true;
          }
        });
      },
      winnerListHandler(winnerList) {
        let self = this;
        self.isWinner = false;
        for (let i in winnerList) {
          let winner = winnerList[i];
          winner.showName = self.getShowName(winner);
          winner.name =
            winner.name ||
            self.encryptUserInfo(winner.mobile, "mobile") ||
            self.encryptUserInfo(winner.email, "email");
          if (winner.userid == self.user.applicantId) {
            self.isWinner = true;
          }
        }
        return winnerList;
      }
    },
    otherMethods
  );
}

export function mounted(model) {
  let self = model;
  $subscriber.subscribe("webinarInfo", data => {
    self.webinarInfo = data;
  });
  $subscriber.subscribe("userInfo", data => {
    self.user = data;
  });
  $subscriber.subscribe("onLuckyDraw", data => {
    self.luckyImageUrl = data.data.image;
    self.luckyName = data.data.name;
    self.awardName = data.data.awardName;
    self.message = data.data.message;
    self.isShowLuckyList = false;
    self.isShowWinningList = false;
    self.isShowLuckying = true;
  });
  $subscriber.subscribe("onLuckyDrawEnd", data => {
    self.winnerList = data.data.members;
    self.luckyName = data.data.name;

    self.winnerListHandler(self.winnerList);
    //      for(let i in self.winnerList) {
    //        let winner = self.winnerList[i];
    //        winner.showName = self.getShowName(winner);
    //        winner.name = winner.name || self.encryptUserInfo(winner.mobile, 'mobile') || self.encryptUserInfo(winner.email, 'email');
    //        if(winner.userid == self.user.applicantId){
    //          self.isWinner  = true;
    //        }
    //      }
    self.isShowLuckying = false;
    self.showLuckyList();
  });
  $subscriber.subscribe("getLuckyDrawRoster", () => {
    self.getLuckyDrawRoster();
  });
}
